<template>
  <div class="c_catalog__wrap">
    <div class="c_catalog__block" :style="{opacity: count ? 1 : 0.8}" @click="$router.push({name: 'catalogItem', params: {id: id}})">
      <div class="c_catalog__image-block">
        <template v-if="imagesArray && imagesArray.length > 0">
          <img
              v-if="imagesArray[0].imageFileName"
              class="c_catalog__image"
              :src="`${contentEndpoint}${imagesArray[0].imageFileName}`"
              :alt="title"
              @click="$router.push({name: 'catalogItem', params: {id: id}})"
          />
<!--          <img v-else-if="imagesArray[0].imageBytes" class="c_catalog__image" :src="`data:image/png;base64, ${imagesArray[0].imageBytes}`" :alt="title" @click="$router.push({name: 'catalogItem', params: {id: id}})"/>-->
        </template>
        <template v-else-if="imagesAvailable">
          <CustomLoader :size="48" :loading="true"/>
          <span style="opacity: .6; font-size: 1rem">Загрузка фото</span>
        </template>
        <template v-else>
          <svg xmlns="http://www.w3.org/2000/svg" class="c_catalog__image" style="height: 6rem; width: 6rem;" @click="$router.push({name: 'catalogItem', params: {id: id}})" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><line x1="2" x2="22" y1="2" y2="22"/><path d="M10.41 10.41a2 2 0 1 1-2.83-2.83"/><line x1="13.5" x2="6" y1="13.5" y2="21"/><line x1="18" x2="21" y1="12" y2="15"/><path d="M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59"/><path d="M21 15V5a2 2 0 0 0-2-2H9"/></svg>
          <span style="opacity: .6; font-size: 1rem">Нет фото</span>
        </template>
      </div>

      <div class="c_catalog__card-content">
        <router-link class="c_catalog__title" :to="{name: 'catalogItem', params: {id: id}}">
          {{title}}
        </router-link>

        <div>
          <CustomCountDisplay :count="count"/>
          <template v-if="count > 0">
            <div class="c_catalog__price-block">
              <span class="c_actual-price">{{actualPrice}} р.</span>
              <span v-if="fullPrice && discount != 0" class="c_full-price">{{fullPrice}} р.</span>
            </div>
          </template>
          <template v-else>
            <div class="c_catalog__price-block">
              <span class="c_actual-price"><span class="c_full-price">{{fullPrice}} р.</span></span>
            </div>
          </template>
        </div>

        <button class="c_item__cart-button" v-if="cartCount <= 0" @click="addToCart">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.2rem" height="1.2rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
          <span>В КОРЗИНУ</span>
        </button>
        <div class="c_item__cart-counter" @click="event => event.stopPropagation()" v-else>
          <button
              class="c_item__cart-counter__button"
              :disabled="(cartCount < 1)"
              @click="decrementCart"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>
          </button>

          <span style="font-size: 1rem;">{{cartCount}}</span>

          <button
              class="c_item__cart-counter__button"
              :disabled="cartCount >= count"
              @click="incrementCart"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
          </button>
        </div>
      </div>

      <div class="c_catalog__discount">
        <svg v-if="discount && discount !== '0'" xmlns="http://www.w3.org/2000/svg" style="position:absolute; top: 0; left: 0;" height="100%" viewBox="0 0 24 24" fill="var(--theme-color-7)" stroke="var(--theme-color-7)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <text fill="var(--button-text-color)" x="50%" y="60%" stroke-width="0" font-size=".5rem" text-anchor="middle">{{discount}}%</text>
        </svg>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import CustomLoader from "@/components/UI/CustomLoader";
import CustomCountDisplay from "@/components/UI/CustomCountDisplay";
import CartService from "@/services/cartService";

export default {
  name: "CatalogElement",
  components: {CustomCountDisplay, CustomLoader},
  props:{
    id: {
      type: Number,
      default: 0,
      required: true
    },
    title:{
      type: String,
      default: '',
      required: true
    },
    count: {
      type: Number,
      default: 0,
      required: true
    },
    actualPrice: {
      type: String,
      default: '',
      required: true
    },
    fullPrice: {
      type: String,
      default: ''
    },
    discount: {
      type: String,
      default: ''
    },
    images:{
      type: Array,
      default: ''
    }
  },
  data(){
    return {
      contentEndpoint: process.env.VUE_APP_CONTENT_URL + 'image/',
      imagesAvailable: false,
      imagesArray: this.images,
      cartCount: 0
    }
  },
  mounted() {
    if(this.id !== 0){
      this.cartCount = CartService.countCartItemsById(this.id)
      // this.onLoadImages().then()
    }
  },
  methods: {
    addToCart(event){
      event.stopPropagation()
      CartService.addCartItem(this.id, 1);
      this.cartCount = CartService.countCartItemsById(this.id)
    },
    incrementCart(event){
      event.stopPropagation()
      CartService.increaseCartItem(this.id, 1);
      this.cartCount = CartService.countCartItemsById(this.id)
    },
    decrementCart(event){
      event.stopPropagation()
      CartService.decreaseCartItem(this.id, 1);
      this.cartCount = CartService.countCartItemsById(this.id)
    },
    // async onLoadImages(){
    //   axios.get(`/api/open/items/images/${this.id}`).then(res => {
    //     if(res.data && res.data.length > 0){
    //       this.imagesArray = res.data
    //     }
    //   }).catch(e => {
    //     console.log(e)
    //     this.imagesArray = []
    //   }).finally(() => {
    //     if(this.imagesArray && this.imagesArray.length > 0){
    //       this.imagesAvailable = true;
    //     }else{
    //       this.imagesAvailable = false;
    //     }
    //   })
    // }
  }
}
</script>

<style scoped lang="scss">
*{
  box-sizing: border-box;
}

.c_catalog__wrap{
  position: relative;
  min-width: 100%;
  width: 100%;
  padding: 15px;
}

.c_catalog__block{
  position: relative;
  min-width: 100%;
  overflow: hidden;
  height: 100%;
  max-height: 100%;
  background-color: var(--foreground-color);
  box-shadow: var(--separator-color) 0 0 5px 1px;
  padding: 0;
  border-radius: .8rem;
  border: var(--separator-color) 1px solid;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  transition: all .2s ease;

  &:hover{
    box-shadow: var(--separator-color) 0 0 10px 5px;
  }
}

.c_catalog__image-block{
  min-height: 60%;
  max-height: 60%;
  max-width: 100%;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;

  & > img {
    width: auto;
    height: 100%;
    padding: 0;
    aspect-ratio: inherit;
  }
}

.c_catalog__card-content{
  position: relative;
  box-sizing: border-box;
  padding: .6rem;

  min-height: 40%;
  height: 40%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.c_catalog__title{
  color: var(--text-color);
  width: 100%;
  text-decoration: none;
  transition: all .2s ease;
  font-size: 1.1rem;
  line-height: 1.2rem;
  text-align: left;
  font-weight: 600;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover{
    color: var(--theme-color-7);
  }
}

.c_catalog__image{
  transition: all .2s ease;
  height: 100%;
  padding: .4rem;
  cursor: default;

  &:hover{
    cursor: pointer;
    opacity: .7;
  }
}

.c_catalog__price-block{
  width: 100%;
  text-align: left;
  font-size: 1rem;
  display: flex;
  gap: .4rem;
  align-items: center;
}

.c_actual-price{
  font-size: 100%;
  font-weight: 600;
}

.c_full-price{
  font-size: 80%;
  opacity: .8;
  text-decoration: line-through;
}

.c_catalog__discount{
  position: absolute;
  width: 3rem;
  aspect-ratio: 1;
  left: 0;
  top: 0;
}

.c_catalog__wrap{
  max-height: 22rem;
  height: 22rem;
}

.c_item__cart-button{
  width: 100%;
  text-decoration: none;
  font-size: .9rem;
  height: 2rem;
  border: var(--theme-color-7) 2px solid;
  border-radius: .6rem;
  background-color: var(--theme-color-7);
  cursor: pointer;
  color: var(--button-text-color);

  display: flex;
  justify-content: center;
  gap: .5rem;
  align-items: center;

  &:hover{
    background-color: var(--theme-color-7-d);
    color: var(--button-text-color);
  }

  &:disabled{
    cursor: default;
    opacity: .6;
  }

  &:disabled:hover{
    cursor: default;
    opacity: .6;
    background-color: var(--foreground-color);
    color: var(--text-color);
  }
}

.c_item__cart-counter {
  width: 100%;
  text-decoration: none;
  font-size: .9rem;
  height: 2rem;
  border: var(--theme-color-7-d) 2px solid;
  border-radius: .6rem;
  background-color: var(--theme-color-7-d);
  color: var(--button-text-color);

  display: flex;
  justify-content: space-between;
  gap: .5rem;
  align-items: center;

  &__button {
    height: 100%;
    aspect-ratio: 1;
    border-radius: .55rem;
    border: var(--theme-color-7-d) 2px solid;
    color: var(--button-text-color);
    cursor: pointer;
    background-color: var(--theme-color-7-d);
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover{
      background-color: var(--theme-color-7);
      color: var(--button-text-color);
    }

    &:disabled{
      cursor: default;
      pointer-events: none;
      opacity: .6;
    }

    &:disabled:hover{
      cursor: default;
      opacity: .6;
      background-color: var(--foreground-color);
      color: var(--text-color);
    }
  }
}

@media screen and (max-width: 3000px) {
  .c_catalog__title{
    font-size: 1.1rem;
  }
  .c_catalog__price-block{
    font-size: 1.4rem;
  }
}

@media screen and (max-width: 1280px) {
  .c_catalog__wrap{
    max-height: 22rem;
    height: 22rem;
  }
  .c_catalog__title{
    font-size: .9rem;
    -webkit-line-clamp: 2;
    line-height: 1.1rem;
  }
  .c_catalog__price-block{
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 1200px) {
  .c_catalog__wrap{
    max-height: 24rem;
    height: 24rem;
  }
  .c_catalog__title{
    font-size: 1.1rem;
    -webkit-line-clamp: 2;
    line-height: 1.3rem;
  }
  .c_catalog__price-block{
    font-size: 1.3rem;
  }

}

@media screen and (max-width: 1100px) {
  .c_catalog__wrap{
    max-height: 26rem;
    height: 26rem;
  }
  .c_catalog__title{
    font-size: 1.1rem;
  }
  .c_catalog__price-block{
    font-size: 1.4rem;
  }
}


@media screen and (max-width: 992px) {
  .c_catalog__wrap{
    max-height: 28rem;
    height: 28rem;
  }
  .c_catalog__title{
    font-size: 1.2rem;
    -webkit-line-clamp: 3;
    line-height: 1.5rem;
  }
  .c_catalog__price-block{
    font-size: 1.8rem;
  }
}

//MOBILE
@media screen and (max-width: 768px) {
  .c_catalog__wrap{
    max-height: 22rem;
    height: 22rem;
    padding: 2px 2px;
  }

  .c_catalog__block{
    box-shadow: var(--separator-color) 0 0 2px 0;
    &:hover{
      box-shadow: var(--separator-color) 0 0 5px 1px;
    }
  }
  .c_catalog__title{
    font-size: 1rem;
    -webkit-line-clamp: 3;
    line-height: 1rem;
  }
  .c_catalog__price-block{
    font-size: 1.2rem;
  }

  .c_catalog__discount{
    position: absolute;
    width: 3.5rem;
    aspect-ratio: 1;
    left: 0;
    top: 0;
  }
}
</style>